import * as translation from "./es-ES.json";

export const translationEsES = translation.default;
